import { Button } from '@mantine/core';
import { IconFileTypeXls } from '@tabler/icons-react';

import { Id } from '@feature/utils';

interface EvaluationAnnex6ButtonProps {
  evaluationId: Id;
}

const onDownload = (evaluationId: Id) => {
  window.open(`/api/gov-evaluation/${evaluationId}/download-annex-6-centralized-by-id-xlsx-missing`);
};

export function GovEvaluationAnnex6CentralizedByIdMissingItemsButton({ evaluationId }: EvaluationAnnex6ButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileTypeXls size="24px" />}
      onClick={() => onDownload(evaluationId)}
    >
      Descarcă date lipsă - anexa 6 - centralizată din anexele 5 după id
    </Button>
  );
}
